module.exports = __webpack_public_path__ + "img/Tostatronic Shop-Logo.d370f16a.png";